import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Simran
 * id BAAF741C-C242-49A8-8A16-DA1EC373385D
 * name pan-bottom-right
 * version: 3.0.39
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/pan-bottom-right.svg
 * tags
 */
export const PanBottomRightIcon = createSvgIcon(<><path d="M12,10A2,2 0 0,1 14,12A2,2 0 0,1 12,14A2,2 0 0,1 10,12A2,2 0 0,1 12,10M13,18.65L18.65,13L19,19L13,18.65Z" /></>, 'PanBottomRightIcon');
export default PanBottomRightIcon